<template>
  <div id="dasbor">
    <left-bar v-model="drawerL"></left-bar>
    <topbar @toggleL="drawerL = !drawerL" @toggleR="drawerR = !drawerR"></topbar>
    <right-bar v-if="!loading" v-model="drawerR"></right-bar>
    <v-main>
      <v-container class="pa-0" fluid>
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>
  </div>
</template>
<script>
import Topbar from '@components/navbar/Topbar';
import LeftBar from '@components/navbar/SideLBar';
import RightBar from '@components/navbar/SideRBar';
import { mapState, mapGetters } from 'vuex';
export default {
  components: {
    Topbar,
    LeftBar,
    RightBar,
  },
  data: () => ({
    drawerL: true,
    drawerR: false,
  }),
  computed: {
    ...mapState(['loading']),
    ...mapGetters('auth', ['role']),
  },
};
</script>
